<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconParticipant_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M11.677 4.909A3.68 3.68 0 0 1 8 8.587a3.68 3.68 0 0 1-3.678-3.678A3.68 3.68 0 0 1 8 1.233a3.68 3.68 0 0 1 3.677 3.676M8 10.158c3.254 0 5.062.762 6.021 1.788l.014.015c.278.295.707.752.885 1.888a1.004 1.004 0 0 1-.992 1.15H2.072c-.61 0-1.085-.547-.992-1.15.174-1.114.59-1.567.848-1.848l.026-.03c.953-1.038 2.764-1.813 6.046-1.813"
        clip-rule="evenodd"
    />
</svg>
